import * as React from 'react';
import { Link } from 'react-router-dom';
import { Result } from 'antd';

import Button from '../../components/button';

const NotFoundPage: React.FC = () => (
  <Result
    status="404"
    title="404"
    subTitle="Sorry, the page you visited does not exist."
    extra={
      <Link to="/">
        <Button styleType="primary">Back Home</Button>
      </Link>
    }
  />
);
export default NotFoundPage;
